// extracted by mini-css-extract-plugin
export default {"box_container":"styles_box_container__nSFF9"};